import { StatusBar } from "expo-status-bar";
import React from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TextInput,
} from "react-native";
import Text from "app/components/Text";
import Value from "app/components/Value";
import Timeline from "app/components/Timeline";
import Generation from "app/components/Generation";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import valueHelpers from "app/utils/valueHelpers";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";

import store from "app/redux/store";
import Form from "app/components/Form";

export default class ReviseView extends React.Component {
  constructor(props) {
    super(props);
    let { navigation, route } = this.props;
    const { id, timestamp } = route.params;
    this.state = {
      value: this.setValue(id),
      children: this.setChildren(id),
      parents: this.setParents(id),
      id,
      timestamp,
      submitting: false,
      error: false,
      // fetching: !value?.id,
    };
  }

  setValue = (id) => {
    let { values } = store.getState();
    let value = { ...values.find((v) => v.id == id) };
    value.child_ids = this.setChildren(id).map((v) => v.id);
    value.parent_ids = this.setParents(id).map((v) => v.id);
    value.created_at = new Date();
    return value;
  };

  setChildren = (id) => {
    let { values } = store.getState();
    let value = { ...values.find((v) => v.id == id) };
    let children = valueHelpers.getChildren({ value });
    let activeChildren = children.filter(
      (v) => !v.completed_at && !v.archived_at
    );
    return activeChildren;
  };

  setParents = (id) => {
    let { values } = store.getState();
    let value = { ...values.find((v) => v.id == id) };
    let parents = valueHelpers.getParents({ value });
    let activeParents = parents.filter(
      (v) => !v.completed_at && !v.archived_at
    );
    return activeParents;
  };

  async componentDidMount() {
    // let { value, id, } = this.state
    // value = await valueActions.get(id)
    // if(!value){
    //   this.setState({fetching: false, error: true})
    // }
    // else {
    //   console.log('fetched:', value)
    //   this.setState({value, fetching: false})
    // }
  }

  handleSubmit = async () => {
    this.setState({ submitting: true });
    let { value, timestamp } = this.state;
    value = await valueActions.revise(value, timestamp);
    if (!!value) {
      this.props.navigation.push("Value", { id: value.id });
    } else {
      this.setState({ submitting: false, error: true });
    }
  };

  handleChangeValue = (key, val) => {
    if (key == "completed_at") {
      this.setState({ timestamp: val });
    }
    let { value } = this.state;
    value[key] = val;
    this.setState({ value });
  };

  render() {
    let { navigation, route } = this.props;
    let { value, parents, children, submitting, fetching } = this.state;
    if (fetching) return null;
    return (
      <View style={{ flex: 1 }}>
        <ScrollView>
          <Form
            value={value}
            parents={parents}
            children={children}
            onChangeValue={this.handleChangeValue}
            onSubmit={this.handleSubmit}
            submitting={submitting}
            showMore
            expandNotes
            revising={true}
            // route={route}
            // navigation={navigation}
          />
          {/*<Text>Timeline:</Text>
          <Timeline value={value} />*/}
          {/*<View>
            {fetching && <View style={[styles.row]}><ActivityIndicator/></View>}
            <View style={[styles.row]}>
              {!!value.parents && value.parents.map(v => (
                <Generation 
                  value={v}
                  nextGen={v['parents'] || []}
                  genKey={'parents'}
                  level={1}
                  navigation={navigation}
                />
              ))}
            </View>
            {!fetching && (<View style={[styles.row]}>
              <Value 
                value={value} 
                conduitSymbols
                // onPress={() => this.toggleTimeline(value)}
              />
            </View>)}
            <View style={[styles.row]}>
              {!!value.children && value.children.map(v => (
                <Generation 
                  value={v}
                  nextGen={v['children'] || []}
                  genKey={'children'}
                  level={-1}
                  navigation={navigation}
                />
              ))}
            </View>
          */}
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  row: {
    zIndex: -1,
    flex: -1,
    flexDirection: "row",
    alignSelf: "stretch",
    justifyContent: "space-around",
    flexWrap: "wrap",
    // paddingLeft: sizes.base,
  },
});
